import { type ReactNode, Suspense, useEffect, useState } from 'react';

// Mounts lazy overlays (drawers, modals) once they are first opened and keeps
// them mounted so Mantine can play the close transition.
export function LoadOnOpen({
  children,
  open,
}: {
  children: ReactNode;
  open: boolean;
}) {
  const [loaded, setLoaded] = useState(open);

  useEffect(() => {
    if (open) setLoaded(true);
  }, [open]);

  if (!open && !loaded) return null;

  return <Suspense fallback={null}>{children}</Suspense>;
}
